import { render, staticRenderFns } from "./InfoSolidIcon.vue?vue&type=template&id=66ffce2f&"
import script from "./InfoSolidIcon.vue?vue&type=script&lang=js&"
export * from "./InfoSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports